import { useTech } from './tech'
import { useSummaries } from '~/stores/summaries'

export const useCertifications = defineStore('certifications', () => {
  const { $api } = useNuxtApp()

  const tech = useTech()
  const selected = ref(null)
  const selectedLevel = ref('senior')

  const displayLevels = {
    junior: 'Junior',
    intermediate: 'Intermediate',
    senior: 'Senior'
  }

  const list = computed(() => tech.certifications || [])

  const all = ref([])

  const trial = computed(() => tech.certifications?.find(cert => cert.slug.includes('trial')))

  const senior = computed(() => tech.certifications?.find(cert => cert.display_level === 'senior' || cert.difficulty_level === 3))

  const intermediate = computed(() => tech.certifications?.find(cert => cert.display_level === 'intermediate' || cert.difficulty_level === 2))

  const junior = computed(() => tech.certifications?.find(cert => cert.display_level === 'junior' || cert.difficulty_level === 1))

  async function getTrialSummary () {
    return await useSummaries().getOne(
      { slug: trial.value.slug },
      { fresh: true }
    )
  }

  async function getAll () {
    const { data } = await $api.get('/certifications')
    all.value = data.map((cert) => Object.assign(cert, { tech: getCertificationTech(cert.id, data) }))
  }

  function getCertificationTech (id, certsList) {
    if (!id) {
      return
    }

    const cert = (certsList || list.value.concat(all.value)).find(c => c.id === id)

    if (!cert) {
      return
    }
    const availableTechs = Object.keys(tech.techThemes)

    for (const techId of availableTechs) {
      if (cert.slug.includes(techId)) return techId
    }
    return 'vuejs'
  }

  return { all, list, selectedLevel, selected, senior, intermediate, junior, trial, displayLevels, getTrialSummary, getAll, getCertificationTech }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCertifications, import.meta.hot))
}
